export default __webpack_public_path__ + "static/media/search-no-results.9d287e3e.svg";